<template>
	<section v-if="(passive && isActive) || !passive" v-show="(!passive && isActive) || passive" :aria-hidden="!isActive ? true : null" class="nk-stabs-panel h-100" role="tabpanel">
		<slot></slot>
	</section>
</template>

<script>
	export default {
		name: 'stab-item',
		props: {
			id: { type: String, required: true },
			name: { type: String, required: true },
			isDisabled: { default: false },
			passive: { default: false, type: Boolean },
			closable: { type: Boolean, default: false },
		},

		data() {
			return {
				isActive: false,
				isVisible: true
			}
		},
		mounted() {
			this.$parent.tabs.push(this)
		},
		unmounted() {
			const index = this.$parent.tabs.findIndex(x => x.id === this.id)
			if (index > -1)
				this.$parent.tabs.splice(index, 1)
		}
	}
</script>
